module.exports = __webpack_public_path__ + "static/media/github-login-logo.2a67d63b.png";